// extracted by mini-css-extract-plugin
module.exports = {"roadster__description":"Roadster_roadster__description__1H3id"};